import * as C from '@/consts'
import component from '@/libs/component'

const ConfirmEmail = () => import(/* webpackChunkName: "forget" */ './ConfirmEmail')
const Reseted = () => import(/* webpackChunkName: "forget" */ './Reseted')

export default [
  {
    path: 'forget',
    name: 'forget',
    redirect: { name: 'forget/confirm-email' }
  },
  {
    path: 'forget/confirm',
    name: 'forget/confirm-email',
    ...component(ConfirmEmail),
    meta: {
      type: C.PAGE_LOGIN
    }
  },
  {
    path: 'forget/reseted',
    name: 'forget/reseted',
    ...component(Reseted),
    meta: {
      type: C.PAGE_LOGIN
    }
  }
]
